import { Icon } from '@ipfabric/ui-components/Icon/Icon';
import { Link } from '@ipfabric/ui-components/Link/Link';
import type { FC } from 'react';

export const AimDevicesEmptyState: FC = () => {
  return (
    <div>
      No device data yet. Use the
      <Icon className='mx-3xs' glyph='fa-arrows-rotate' inline />
      button in the Flows calculated column of the{' '}
      <Link to='/inventory/applications'>Applications</Link> table, or the
      Calculate link in the Calculation status column of the{' '}
      <Link to='/inventory/applications/flows'>Flows</Link> table, to collect
      it.
    </div>
  );
};
